import { render, staticRenderFns } from "./ProjectSocialInsights.vue?vue&type=template&id=71e9c134&"
import script from "./ProjectSocialInsights.vue?vue&type=script&lang=js&"
export * from "./ProjectSocialInsights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports